import { ENV } from "../util/env";
export const apiBaseUrl = ENV.CUSTOMER_ENDPOINT;
export const analyticsApiBaseUrl = ENV.ANALYTICS_ENDPOINT;
